<template>
    <div class="field-wrapper">
        <label v-if="label" :id="`label-${$attrs.id}`" :for="$attrs.id" class="label-outside">{{ label }}</label>
        <div class="input-container-wrapper">
            <div class="input-container" :class="classes">
                <input
                    v-bind="$attrs"
                    :value="modelValue"
                    :class="{ error: errorMsg }"
                    :aria-labelledby="`error${$attrs.id} label-${$attrs.id}`"
                    @input="updateValue"
                    @change="updateValue"
                    @blur="handleBlur"
                />
            </div>
            <span v-if="complement" class="complement" aria-hidden="true">{{ complement }}</span>
        </div>
        <p v-show="displayError" :id="`error${$attrs.id}`" class="form-error" aria-live="assertive">{{ displayError }}</p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useField } from 'vee-validate';

const emit = defineEmits(['update:modelValue', 'blur']);

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: '',
    },
    label: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        required: false,
        default: '',
    },
    size: {
        type: String,
        default: ''
    },
    complement: {
        type: String,
        default: ''
    },
    rules: {
        type: String,
        default: '',
    },
    name: {
        type: String,
        required: true,
    },
});

defineOptions({
    inheritAttrs: false,
});

const {
    value: fieldValue,
    errorMessage,
    handleBlur: veeHandleBlur,
    handleChange,
} = useField(() => props.name, props.rules, {
    initialValue: props.modelValue,
    syncVModel: true,
});

const displayError = computed(() => {
    return props.error || errorMessage.value || '';
});

const errorMsg = computed(() => {
    return displayError.value !== '';
});

const classes = computed(() => {
    return {
        error: errorMsg.value,
        'medium-input': props.size === 'medium',
        'small-input': props.size === 'small',
    };
});

const updateValue = (e) => {
    const newValue = e.target.value;
    emit('update:modelValue', newValue);
    handleChange(newValue);
};

const handleBlur = (e) => {
    veeHandleBlur(e);
    emit('blur', e);
};
</script>

<style lang="scss" scoped>
.label-outside {
    margin-bottom: 0;
}
.complement {
    margin-left: rem(8px);
}
.input-container-wrapper {
    width: auto;
    display: flex;
    align-items: center;
}
.small-input input {
    width: 100px;
}
</style>
